export default __webpack_public_path__ + "static/media/crowd.814bfd77.jpg";